import "bootstrap/dist/css/bootstrap.min.css";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import useParamsReported from '../../helpers/useParamsReported';
import dateFormat from '../../services/DateFormat.service';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import '../../DataTableDemo.css';
import ConfBar from '../ConfBar/ConfBar';
import { LabelField } from './Reported.styles';
import Video from '../Video/Video';
import SkeletonTable from "../SkeletonTable/SkeletonTable";
import { FileUpload } from "primereact/fileupload";
import { saveAs } from 'file-saver';
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { excelReport } from "../../services/excelReport.service";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Reported
Description : Tabla para la creación de reportados.
Date Autor Modification
================================================================================
27/10/2021 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
================================================================================ */


export default function Reported() {

  const [listaReportadas, setListaReportadas] = useState([]);
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [listaCalendario, setListaCalendario] = useState([]);
  const [listaNieDed, setListaNieDed] = useState([]);
  const [listaNieDev, setListaNieDev] = useState([]);
  const [listasCargadas, setListasCargadas] = useState(false)
  const [listasCargadasConcepto, setListasCargadasConcepto] = useState(false)

  const [codEmpleado, setCodEmpleado] = useState("");
  const [concepto, setConcepto] = useState("");
  const [valor, setValor] = useState("");
  const [calendario, setCalendario] = useState("");
  const [nie, setNie] = useState("");
  const [idOcasional, setIdOcasional] = useState("");
  const [observaciones, setObservaciones] = useState("")
  const [historico, setHistorico] = useState([])
  const [isOpenNovelties, setIsOpenNovelties] = React.useState(false);

  const [params] = useParamsReported();

  const [nombreConcepto, setNombreConcepto] = useState("");
  const [naturaleza, setNaturaleza] = useState("");
  const [tipoConcepto, setTipoConcepto] = useState("");
  const [tipoRetencion, setTipoRetencion] = useState("");
  const [agregado, setAgregado] = useState(false);

  const [listaNaturaleza, setListaNaturaleza] = useState([]);
  const [listaTipoConcepto, setListaTipoConcepto] = useState([]);
  const [listaTipoRetencion, setListaTipoRetencion] = useState([]);

  const [rowId, setRowId] = useState(0);

  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenC, setIsOpenC] = React.useState(false);
  const [isOpenH, setIsOpenH] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [consultado, setConsultado] = useState(false);
  const [loadPage, setLoadPage] = useState(false);
  const [listaCYR, setListaCYR] = useState([])
  const [cyr, setCyr] = useState("")

  const headers = {
    authorization: localStorage.getItem('token')
  }

  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "22rem", justifySelf: "center" }

  const toast = useRef(null);
  const fileUploadRef = useRef(null);

  useEffect(() => {
    setTabla();
  }, [rowId]);

  useEffect(() => {
    const historicTemplate = async () => {
      /*Se inicializan las propiedades del componente para la generación de reportes*/
      let plantilla = []
      params.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setHistorico(plantilla)
    }
    historicTemplate()
  }, [params]);

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModal()} />
        <Button label="Agregar concepto" icon="pi pi-calendar-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModalC()} />
        <Button label="Reporte histórico" icon="pi pi-file-excel" className="p-button-sucess mr-2 p-button-sm" onClick={() => showModalH()} />
        <Button type="button" icon="pi pi-upload" label="Cargar novedades" tooltip='Proceso cargue masivo reportados'
          className="p-button-success mr-2 p-button-sm" onClick={() => showModalNovelties()} tooltipOptions={{ position: 'top' }} />
      </React.Fragment>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Actualizar reportado" tooltipOptions={{ position: 'top' }} onClick={() => { setIdOcasional(rowData["ID"]); initializeData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar reportado" tooltipOptions={{ position: 'top' }} onClick={() => { setIdOcasional(rowData["ID"]); showModalEliminar() }} />
      </div>
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'VALUE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CALENDAR': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  const showModal = () => {
    if (!listasCargadas) {
      setListas()
    }
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
    limpiar();
  };

  const showModalEliminar = () => {
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalC = () => {
    if (!listasCargadasConcepto) {
      setListasConceptos()
    }
    setIsOpenC(true);
  };

  const hideModalC = () => {
    setIsOpenC(false);
    limpiar();
  };

  const showModalH = () => {
    setIsOpenH(true);
  };

  const hideModalH = () => {
    setIsOpenH(false);
  };

  const showModalNovelties = () => {
    setIsOpenNovelties(true);
  };

  const hideModalNovelties = () => {
    setIsOpenNovelties(false);
  };

  async function limpiar() {
    setCodEmpleado("");
    setConcepto("");
    setValor("");
    setNie("");
    setIdOcasional("");
    setCalendario("");
    setNombreConcepto("");
    setNaturaleza("");
    setTipoConcepto("");
    setTipoRetencion("");
    setObservaciones("")
  }

  const GetCalendar = async (contract = "") => {
    await apis.getNoveltiesCalendar(contract, headers).then(res => {
      let lista = res.data["CALENDAR"]
      let contenidoCalendario = []
      lista.forEach(element => {
        contenidoCalendario.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
      })
      setListaCalendario(contenidoCalendario)
    })
  }

  async function setListas() {

    GetCalendar()

    await apis.getReportedLists(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
      let codsEmpleados = res.data["CONTRACTS"]
      let reportadas = res.data["CONCEPTS"]
      let contenidoReportadas = []
      let contenidoCodEmpleado = []
      codsEmpleados.forEach(element => {
        contenidoCodEmpleado.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
      })
      reportadas.forEach(element => {
        contenidoReportadas.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
      })
      setListaReportadas(contenidoReportadas);
      setListaCodEmpleado(contenidoCodEmpleado);
      setListasCargadas(true)
    })
  }

  async function setListasConceptos() {
    try {
      await apis.getValueListReportedConcepts(headers).then(res => {
        let listas = res.data["TYPE_CONCEPTS"]
        let contenidoNaturaleza = [
          { DETAIL_ID: listas[0]["DETAIL_ID"], DESCRIPTION: listas[0]["DESCRIPTION"] },
          { DETAIL_ID: listas[1]["DETAIL_ID"], DESCRIPTION: listas[1]["DESCRIPTION"] }
        ]
        let contenidoTipoConcepto = listas[0]["OPTIONS"][0]["LITE_TIPO_CONCEPTO"]
        let contenidoTipoRetencion = listas[0]["OPTIONS"][1]["LITE_BASE_RETE"]
        let contenidoNieDev = listas[0]["OPTIONS"][2]["NIE_DEV"]
        let contenidoNieDed = listas[1]["OPTIONS"][0]["NIE_DED"]
        let contenidoCYR = res.data["CYR"]
        setListaNaturaleza(contenidoNaturaleza)
        setListaTipoConcepto(contenidoTipoConcepto)
        setListaTipoRetencion(contenidoTipoRetencion)
        setListaNieDev(contenidoNieDev)
        setListaNieDed(contenidoNieDed)
        setListaCYR(contenidoCYR)
        setListasCargadasConcepto(true)
      })
    }
    catch (err) {
      console.log("Wait")
    }
  }

  async function setTabla() {
    await apis.getReported(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["NOVELTIES"].length > 0) {
        let data = res.data["NOVELTIES"]
        let contenidoTabla = []
        data.forEach(element => {
          let concepto = element["CONCEPT_ID"].split("|")
          let datos = element["NAME"].split("|")
          let calendario = element["ID_CALENDAR"].split("|")
          contenidoTabla.push({
            ID: element.OCCASIONAL_ID, CONTRACT_ID: element.CONTRACT_ID, NUMBER_ID: datos[0], NAME: datos[1], CONCEPT_ID: datos[0],
            CONCEPT: concepto[1], VALUE: element.VALUE, CALENDAR_ID: calendario[0], CALENDAR: calendario[1], OBSERVATIONS: element.OBSERVATIONS
          })
        })
        setRows(contenidoTabla)
        setRowData(contenidoTabla)
        setLoadPage(true)
      }
      else {
        setRows([])
        setRowData([])
        setLoadPage(true)
      }
    })
  }

  async function completarRegistro() {
    let empleado = codEmpleado.split('|')

    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _codEmpleado = empleado[0];
    const _concepto = concepto.value;
    const _valor = valor;
    const _calendario = calendario.value;
    const _observaciones = observaciones

    const report = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      CONTRACT_ID: _codEmpleado,
      CONCEPT_ID: _concepto,
      VALUE: _valor,
      OBSERVATIONS: _observaciones
    }

    try {
      await apis.postReported(report, headers).then(res => {
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Reportada agregada exitosamente' });
      })
      setTabla();
      limpiar();
      hideModal();
    } catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function actualizar() {

    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario;
    const _codEmpleado = codEmpleado;
    const _concepto = concepto;
    const _idOcasional = idOcasional;
    const _valor = valor;
    const _observaciones = observaciones

    const report = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      CONTRACT_ID: _codEmpleado,
      CONCEPT_ID: _concepto,
      OCCASIONAL_ID: _idOcasional,
      VALUE: _valor,
      OBSERVATIONS: _observaciones
    }

    console.log(report)

    try {
      await apis.putReported(report, headers).then(res => {
        setLoading2(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Reportada actualizada exitosamente' });
      })

      setTabla();
      limpiar();
      hideModal_();
    } catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }

  }

  async function eliminar() {

    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _idOcasional = idOcasional

    try {
      await apis.deleteReported(_entity, _cliente, _idOcasional, headers).then(res => {
        console.log(res.data)
        setLoading3(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Reportada eliminada exitosamente' });
      })

      setTabla();
      limpiar();
      hideModalEliminar();
    } catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
    }
  }

  async function postReportedConcept() {
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _nombre = nombreConcepto
    const _naturaleza = naturaleza.DETAIL_ID
    const _nie = nie.detail_id
    const _modulo = "OCA"
    const _cyr = cyr.IDGROUP
    let _tipoConcepto = ""
    let _tipoRetencion = ""

    if (_naturaleza === "367") {
      _tipoConcepto = tipoConcepto.detail_id
      _tipoRetencion = tipoRetencion.detail_id
    }

    const concept = {
      CLIENT: _cliente,
      ENTITY: _entity,
      NAME: _nombre,
      TYPE_CONCEPTS: _naturaleza,
      MODULE: _modulo,
      TYPE_CONCEPT: _tipoConcepto,
      TYPE_RETE: _tipoRetencion,
      NE_DIAN: _nie,
      CYR: _cyr
    }

    try {
      await apis.postReportedConcept(concept, headers).then(res => {
        // setAgregado(true)
        limpiar();
        setLoading4(false)
        hideModalC()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Concepto agregado exitosamente' });
      })
      setListas()
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
    }
  }

  async function postReportedReport() {

    /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    historico.forEach(h => {
      let size = h.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    historico.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      await apis.postReportedReport(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "reporteNovedadesReportadas")
        setLoading5(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de novedades reportadas generado existosamente" });
        hideModalH();
      })
    }
    catch (err) {
      setLoading5(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  function initializeData(rowData) {
    setIdOcasional(rowData.ID);
    setCodEmpleado(rowData.CONTRACT_ID);
    setConcepto(rowData.CONCEPT_ID)
    setCalendario(rowData.CALENDAR_ID)
    setValor(rowData.VALUE);
    showModal_();
  }

  async function downloadSampleFile() {
    let payload = {
      NAME: "UploadAccumulated",
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.importReported(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading6(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading6(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.importReported(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importNovelties(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0]

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadAccumulated",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  const addFooter = (
    <div>
      <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); completarRegistro() }} />
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar reportado</h3>
    </div>
  )

  const updateFooter = (
    <div>
      <Button onClick={() => { setLoading2(false); hideModal_() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); actualizar() }} />
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar reportado</h3>
    </div>
  )

  const deleteFooter = (
    <div>
      <Button onClick={() => { setLoading3(false); hideModalEliminar() }}>Cancelar</Button>
      <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); eliminar() }} />
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el reportado?</h3>
    </div>
  )

  const conceptFooter = (
    <div>
      <Button onClick={() => { setLoading4(false); hideModalC() }}>Cancelar</Button>
      <Button label="Agregar" loading={loading4} onClick={() => { setLoading4(true); postReportedConcept() }} />
    </div>
  );

  const conceptHeader = (
    <div>
      <h3>Agregar concepto</h3>
    </div>
  )

  const footerHS = (
    <div>
      <Button label='Generar' loading={loading5} onClick={() => { setLoading5(true); postReportedReport() }} />
    </div>
  );

  const headerHS = (
    <div>
      <h3>Parámetros reporte novedades reportadas</h3>
    </div>
  )

  /*Header y footers de los modales del componente*/
  const footer = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading6(false); setLoading7(false); hideModalNovelties() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading6} onClick={() => { setLoading6(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importNovelties}>
      </FileUpload>
    </div>
  );

  const header = (
    <div>
      <h3>Cargar reportados</h3>
    </div>
  )

  /*Funciones que manejan el cambio en los campos de entrada del modal de gneración del reporte*/
  function handleChangeH(e, d, index) {
    setHistorico(h => {
      let newHistorico = [...h]
      console.log(index)
      console.log(h)
      newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeDateH(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeTextH(e, d, index) {
    console.log(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  const formatCurrency = (value) => {
    let currency = parseInt(value)
    return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
  }

  const valueBodyTemplate = (rowData) => {
    if (rowData.VALUE !== undefined || rowData.VALUE !== '') {
      return formatCurrency(rowData.VALUE);
    }
    else {
      return rowData.VALUE;
    }
  }

  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={addHeader} footer={addFooter} visible={isOpen}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          <LabelField htmlFor="label">Código empleado *</LabelField>
          <Dropdown filter showClear filterBy="label" style={elementWidth} value={codEmpleado} options={listaCodEmpleado} placeholder={"Seleccione un Empleado"}
            onChange={(e) => { setCodEmpleado(e.value); GetCalendar(e.value) }} />
          <LabelField htmlFor="label">Calendario *</LabelField>
          <Dropdown style={elementWidth} value={calendario.value}
            filter showClear filterBy="label" emptyMessage={"No hay calendarios disponibles"}
            options={listaCalendario} placeholder={"Seleccione calendario"} disabled={!codEmpleado}
            onChange={(e) => {
              let label = e.originalEvent.nativeEvent.target.textContent;
              setCalendario({ "value": e.value, "label": label })
            }}
          />
          <LabelField htmlFor="label">Concepto *</LabelField>
          <Dropdown style={elementWidth} value={concepto.value} disabled={!codEmpleado}
            filter showClear filterBy="label" emptyMessage={"No hay conceptos disponibles"}
            options={listaReportadas} placeholder={"Seleccione concepto"}
            onChange={(e) => {
              let label = e.originalEvent.nativeEvent.target.textContent;
              setConcepto({ "value": e.value, "label": label })
            }}
          />
          <LabelField htmlFor="label">Valor *</LabelField>
          <InputNumber value={valor} style={elementWidth} disabled={!codEmpleado}
            onValueChange={(e) => { setValor(e.value) }}
            mode="currency" currency="COP" locale="es-CO" />
          <LabelField htmlFor="label">Observaciones</LabelField>
          <InputTextarea maxLength={70} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} rows={4} cols={30} style={elementWidth} disabled={!codEmpleado} />
        </Dialog>
        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          <LabelField htmlFor="label">Valor *</LabelField>
          <InputNumber value={valor} style={elementWidth}
            onValueChange={(e) => { setValor(e.value) }}
            mode="currency" currency="COP" locale="es-CO" />
        </Dialog>
        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>
        <Dialog header={conceptHeader} footer={conceptFooter} visible={isOpenC}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalC}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          <LabelField htmlFor="label">Nombre *</LabelField>
          <InputText
            style={elementWidth}
            id="label2"
            autoFocus
            type="text"
            value={nombreConcepto}
            placeholder="Nombre"
            onChange={(e) => setNombreConcepto(e.target.value)}
          />
          <LabelField htmlFor="label">Naturaleza *</LabelField>
          <Dropdown style={elementWidth} value={naturaleza}
            filter showClear filterBy="DESCRIPTION"
            optionLabel="DESCRIPTION" emptyMessage={"No hay naturalezas disponibles"}
            options={listaNaturaleza} placeholder={"Seleccione naturaleza"}
            onChange={(e) => {
              setNaturaleza(e.value)
            }}
          />
          {naturaleza !== undefined ? (naturaleza.DETAIL_ID === "367" ?
            <>
              <LabelField htmlFor="label">Tipo concepto *</LabelField>
              <Dropdown style={elementWidth} value={tipoConcepto}
                filter showClear filterBy="description"
                optionLabel="description" emptyMessage={"No hay tipos disponibles"}
                options={listaTipoConcepto} placeholder={"Seleccione tipo"}
                onChange={(e) => {
                  setTipoConcepto(e.value)
                }}
              />
            </> : null)
            : null}
          {naturaleza !== undefined ? (naturaleza.DETAIL_ID === "367" ?
            <>
              <LabelField htmlFor="label">¿Hace base de retención? *</LabelField>
              <Dropdown style={elementWidth} value={tipoRetencion}
                filter showClear filterBy="description"
                optionLabel="description" emptyMessage={"No hay opciones disponibles"}
                options={listaTipoRetencion} placeholder={"Seleccione opción"}
                onChange={(e) => {
                  setTipoRetencion(e.value)
                }}
              />
            </> : null)
            : null}

          {naturaleza !== undefined ? (naturaleza.DETAIL_ID === "367" ?
            <>
              <LabelField htmlFor="label">NIE DIAN *</LabelField>
              <Dropdown style={elementWidth} value={nie}
                filter showClear filterBy="description"
                optionLabel="description" emptyMessage={"No hay NIE disponible"}
                options={listaNieDev} placeholder={"Seleccione NIE"}
                onChange={(e) => {
                  setNie(e.value)
                }}
              />
            </> : <>
              <LabelField htmlFor="label">NIE DIAN *</LabelField>
              <Dropdown style={elementWidth} value={nie}
                filter showClear filterBy="description"
                optionLabel="description" emptyMessage={"No hay NIE disponible"}
                options={listaNieDed} placeholder={"Seleccione NIE"}
                onChange={(e) => {
                  setNie(e.value)
                }}
              />
            </>)
            :
            <>
              <LabelField htmlFor="label">NIE DIAN *</LabelField>
              <Dropdown style={elementWidth} value={nie}
                filter showClear filterBy="description"
                optionLabel="description" emptyMessage={"No hay NIE disponible"}
                options={listaNieDed} placeholder={"Seleccione NIE"}
                onChange={(e) => {
                  setNie(e.value)
                }}
              />
            </>
          }
          <LabelField htmlFor="label">Grupo de Certificado de Ingresos y Retenciones</LabelField>
          <Dropdown style={{ width: "22rem" }} value={nie}
            filter showClear filterBy="NAME"
            optionLabel="NAME"
            options={listaCYR} placeholder={cyr ? cyr.NAME : "Seleccione un grupo"}
            onChange={(e) => {
              setCyr(e.value)
            }}
          />
        </Dialog>
        <Dialog header={headerHS} footer={footerHS} visible={isOpenH} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalH}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {params.map((d, index) => {
            /*Generación dinámica de los parámetros para la generación del reporte histórico de ausentismos*/
            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historico.length > 0 && typeof historico[index] !== "undefined") {
              let label = d.LABEL;
              if (d.REQUIRED === "1") {
                label = label + "*"
              }
              switch (d.TYPE) {
                case "LIST":
                  let options = []
                  if (d.REQUIRED === "1") {
                    options = [...d.OPTIONS]
                  }
                  else {
                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                  }
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Dropdown
                      key={index}
                      style={elementWidth}
                      value={historico[index]["NAME"]}
                      options={options}
                      filter showClear filterBy="NAME"
                      optionLabel="NAME"
                      emptyMessage={"No hay " + label + "s disponibles"}
                      //optionTemplate={optionTemplate}
                      placeholder={historico[index]["NAME"] ? historico[index]["NAME"] : "Seleccione"}
                      onChange={(e) => handleChangeH(e, d, index)}
                    />
                  </>
                  );
                case "DATE":
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Calendar key={d} style={elementWidth} id="navigators" value={historico[index].CODE}
                      onChange={(e) => handleChangeDateH(e, d, index)}
                      locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historico[index].CODE}
                      yearRange="2010:2030" /></>
                  );
                default:
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <InputText
                      key={d}
                      style={elementWidth}
                      id="label2"
                      type="text"
                      value={historico[index]}
                      onChange={(e) => handleChangeTextH(e, d, index)}
                    /></>
                  )
              }
            }
          })}
        </Dialog>
        <Dialog header={header} footer={footer} visible={isOpenNovelties}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalNovelties}>
          <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
          <br />
          <span>2. Diligencie la hoja UploadNov_reported, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
          <br />
          <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Reportados</span>
          <Video header="Instructivo proceso novedades" url={localStorage.getItem('NOVELTIESREPORTED_VIDEO')} />
        </div>
        <ConfBar />
        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
            <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'CONCEPT', 'VALUE', 'CALENDAR']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="CONCEPT" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
              <Column field="VALUE" header="Valor" body={valueBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo de contrato" sortable></Column>
              <Column field="CALENDAR" header="Calendario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
              <Column field="OBSERVATIONS" header="Observaciones" showFilterOperator={false} filterMatchModeOptions={matchModes} bodyStyle={{ maxWidth: "12rem" }} filter filterPlaceholder="Buscar por tiempo" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>

  );
}